import React from 'react';
import styled from 'styled-components';
import RotationEffect from '../AnimatedEffects/RotationEffect';

const StyledWrapper = styled.span`
  * {
    color: ${({ theme }) => theme.primary};
    fill: ${({ theme }) => theme.primary};
  }
`;

const HelpIcon = ({
  size = 25,
  rotationEffect = true,
  rotation = 40,
  timing = 200,
  ...props
}) => {
  const icon = (
    <StyledWrapper>
      <svg
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        width={size}
        height={size}
        {...props}
      >
        <g>
          <path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20c-4.5,0-8-3.5-8-8s3.5-8,8-8s8,3.5,8,8S16.5,20,12,20z" />
        </g>
        <rect x="11" y="15" width="2" height="2" />
        <path d="M13,14h-2c0-2.6,2-2.1,2-4.2c0-0.4-0.2-1.3-1.1-1.3c-0.3,0-1,0.5-1,1.5H9c0,0-0.4-3,2.9-3C14.5,7,15,8.9,15,9.8 C15,12.1,13,12.3,13,14z" />
      </svg>
    </StyledWrapper>
  );

  return (
    <>
      {rotationEffect ? (
        <RotationEffect rotation={rotation} timing={timing}>
          {icon}
        </RotationEffect>
      ) : (
        { icon }
      )}
    </>
  );
};

export default HelpIcon;
